import { useState } from "react";
import { Form, Button } from 'reactstrap';
import { APILA } from "../../../../../../config/apila";
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../NotificationToast/ToastError";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faXmark,
  faFloppyDisk
} from '@fortawesome/free-solid-svg-icons';

export default function ModalKkcaAdd(props) {
  const token = localStorage.getItem("token");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const id_user = localStorage.getItem("id_admin");
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };

  const [form, setForm] = useState({
    name_kkca: "",
    persentase: "",
    user_id:"",
  });

  const handleChange = async (e) => {
    setForm({
      ...form,
      [e.target.name] : e.target.value,
    });
  };

  const handleSubmit = useMutation(async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APILA.post("/api/kkca/store", {
        name_kkca: form?.name_kkca,
        persentase: form?.persentase,
        user_id: output_id_user,
      }, fetchParams);
      
      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: 'success',
          title: response.data.message,
        })
        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal menyimpan data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-tambah-kkca"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="modal-tambah-kkca" className="sims-modal-title">
            Tambah KKCA 
          </h5>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="sims-modal-body">
          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="kkca_add">
              Nama KKCA <span>*</span>
            </label>
            <input
              id="kkca_add"
              className="sims-form-input"
              autoFocus
              required
              autoComplete="off"
              type="text"
              name="name_kkca"
              onChange={handleChange}
              value={form.name_kkca}
            />
          </div>

          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="persentase_add">
              Persentase <span>*</span>
            </label>
            <input
              id="persentase_add"
              className="sims-form-input"
              required
              autoComplete="off"
              type="text"
              name="persentase"
              onChange={handleChange}
              value={form.persentase}
             
            />

          </div>
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                Menyimpan...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Tambahkan
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
  